(() => {
  'use strict';
  function initialize(scope = document) {
    scope.querySelectorAll('[data-product]').forEach(region => {
      const master = region.querySelector('[data-variant-select]');
      const options = region.querySelector('[data-product-options]');
      if (!master || !options || region.dataset.optionsReady) return;
      const controls = [...options.querySelectorAll('[data-option-index]')];
      const variants = [...master.options].map(option => ({option, values: JSON.parse(option.dataset.options)}));
      const button = region.querySelector('[data-add-button]');
      function sync(updateUrl = true) {
        const values = controls.map(control => control.value);
        const match = variants.find(variant => variant.values.every((value, i) => value === values[i]));
        master.value = match?.option.value || '';
        const available = match?.option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = match ? (available ? region.dataset.addLabel : region.dataset.soldLabel) : region.dataset.unavailableLabel;
        region.querySelector('[data-product-price]').textContent = match?.option.dataset.price || region.dataset.unavailableLabel;
        region.querySelector('[data-product-message]').textContent = '';
        const image = region.querySelector('#ProductMainImage');
        if (match?.option.dataset.image && image) { image.removeAttribute('srcset'); image.src = match.option.dataset.image; }
        controls.forEach((control, index) => {
          [...control.options].forEach(option => {
            const exists = variants.some(variant => variant.option.dataset.available === 'true' && variant.values.every((value, i) => i === index ? value === option.value : value === values[i]));
            option.textContent = option.value + (exists ? '' : ' — ' + region.dataset.soldLabel);
          });
        });
        if (updateUrl) { const next = new URL(location.href); match ? next.searchParams.set('variant', master.value) : next.searchParams.delete('variant'); history.replaceState({}, '', next); }
      }
      controls.forEach(control => control.addEventListener('change', () => sync()));
      window.addEventListener('popstate', () => {
        const id = new URL(location.href).searchParams.get('variant');
        const match = variants.find(variant => variant.option.value === id) || variants.find(variant => variant.option.dataset.available === 'true') || variants[0];
        controls.forEach((control, index) => { control.value = match.values[index]; }); sync(false);
      });
      region.querySelector('[data-combined-options]').hidden = true;
      options.hidden = false;
      region.dataset.optionsReady = 'true';
      sync(false);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('click', event => {
    const thumb = event.target.closest('[data-gallery-src]');
    if (thumb) { thumb.parentElement.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(b === thumb))); const image = document.getElementById('ProductMainImage'); if (image) { image.removeAttribute('srcset'); image.src = thumb.dataset.gallerySrc; image.alt = thumb.dataset.galleryAlt; } }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.purchase-form')) return;
    event.preventDefault();
    const region = form.closest('[data-product]');
    const button = form.querySelector('[data-add-button]');
    const message = form.querySelector('[data-product-message]');
    if (button.disabled || form.dataset.submitting === 'true') return;
    const body = new FormData(form);
    if (!body.get('id')) return;
    const controls = [...form.querySelectorAll('select,input,button')];
    const states = controls.map(control => control.disabled);
    form.dataset.submitting = 'true';
    controls.forEach(control => { control.dataset.previousDisabled = String(control.disabled); control.disabled = true; });
    button.setAttribute('aria-busy', 'true'); button.textContent = region.dataset.addingLabel; message.textContent = '';
    try {
      const base = window.Shopify?.routes?.root || '/';
      const response = await fetch(base + 'cart/add.js', {method: 'POST', body, headers: {Accept: 'application/json'}});
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : region.dataset.errorLabel);
      location.assign(base + 'cart');
    } catch (error) {
      message.textContent = error.message === 'Failed to fetch' ? region.dataset.errorLabel : error.message;
      controls.forEach((control, index) => { control.disabled = states[index]; });
      button.removeAttribute('aria-busy'); button.textContent = region.dataset.addLabel;
      form.dataset.submitting = 'false';
    }
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    document.querySelectorAll('.purchase-form[data-submitting="true"]').forEach(form => {
      form.querySelectorAll('[data-previous-disabled]').forEach(control => { control.disabled = control.dataset.previousDisabled === 'true'; });
      form.dataset.submitting = 'false';
      const button = form.querySelector('[data-add-button]');
      button.removeAttribute('aria-busy');
      button.textContent = form.closest('[data-product]').dataset.addLabel;
    });
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('details[open]').forEach(details => { details.open = false; }); });
})();
